function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M392.68,380.34c11.6,0,15.35-11.67,15.35-30.71,0-23.45-17.83-40.3-24.77-56.65-11.46-27-17.17-47.61-28.24-64.56-18-27.58-21-20.47-22.95-30.22-1.9-9.4,3.41-11.78,8.92-39.14,3.84-19.11-2-54.22,1.15-83.73,1.49-14-9.43-25.46-16-27.91-14.2-5.28-47.32,7.29-62.86,10.9-33.41,7.77-67.38-.44-75.36,21.64-9.24,25.59.5,46.4,35.73,98.58,6.66,9.88,24.38,33.36,39.41,45.75,10.75,8.85,27.49,48.47,35.51,60.44,6,8.93,20.15,17.35,24.27,23.94,1.65,2.64-.35,14.38-.66,19.16C321.17,343.19,385.57,380.34,392.68,380.34Z",
  transform: "translate(-183.12 -44.65)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
function SvgDeepWilds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "79.88mm",
    height: "118.96mm",
    viewBox: "0 0 226.42 337.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DeepWilds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepWilds);
export default __webpack_public_path__ + "static/media/DeepWilds.3da7ab466431e3084bc05442659385ef.svg";
export { ForwardRef as ReactComponent };